import React, { useState, useEffect } from 'react';
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    Paper
} from '@mui/material';
import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    fetchSignInMethodsForEmail,
    GoogleAuthProvider
} from 'firebase/auth';
import { auth } from '../firebase/firebase'; // Asegúrate de que este 'auth' está bien configurado
import { useAuth } from '../auth/AuthContext';
import { useNavigate } from 'react-router-dom';

const LoginEmailScreen = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');

    const { currentUser, dbUser } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        console.log('Current User:', currentUser);
        console.log('DB User:', dbUser);
    }, [currentUser, dbUser]);

    // Redirige si currentUser y dbUser existen
    useEffect(() => {
        if (currentUser && dbUser) {
            navigate('/misbolos/profile');
        }
    }, [currentUser, dbUser, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setErrorMsg('');
        setSuccessMsg('');
        setLoading(true);

        try {
            // Intentar iniciar sesión
            await signInWithEmailAndPassword(auth, email, password);
            setSuccessMsg('Inicio de sesión exitoso ✅');
            console.log('Login exitoso');
        } catch (error) {
            console.warn('Login failed:', error.code);

            if (
                error.code === 'auth/invalid-credential' ||
                error.code === 'auth/invalid-login-credentials' ||
                error.code === 'auth/user-not-found'
            ) {
                try {
                    const providers = await fetchSignInMethodsForEmail(auth, email);
                    console.log('Métodos encontrados para este email:', providers);

                    if (providers.includes(GoogleAuthProvider.PROVIDER_ID)) {
                        setErrorMsg('Esta cuenta usa Google para iniciar sesión. Usa el botón de "Iniciar con Google".');
                    } else if (providers.includes('password')) {
                        setErrorMsg('Contraseña incorrecta. Verifica tus datos.');
                    } else if (providers.length === 0) {
                        // Si no existe aún, crear usuario
                        try {
                            await createUserWithEmailAndPassword(auth, email, password);
                            setSuccessMsg('Usuario creado exitosamente ✅');
                        } catch (creationError) {
                            setErrorMsg('Error creando usuario: ' + creationError.message);
                        }
                    } else {
                        setErrorMsg(`Este correo ya está vinculado a otro método de inicio de sesión (${providers.join(', ')})`);
                    }
                } catch (fetchErr) {
                    console.error('Error al verificar los métodos de inicio:', fetchErr);
                    setErrorMsg('Error al verificar email: ' + fetchErr.message);
                }
            } else if (error.code === 'auth/wrong-password') {
                setErrorMsg('Contraseña incorrecta.');
            } else if (error.code === 'auth/too-many-requests') {
                setErrorMsg('Demasiados intentos fallidos. Inténtalo más tarde.');
            } else {
                setErrorMsg(error.message || 'Error al iniciar sesión.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{ p: 4, mt: 6 }}>
                <Typography variant="h5" gutterBottom>
                    Iniciar sesión con correo y contraseña
                </Typography>

                <Alert severity="info" sx={{ mb: 2 }}>
                    ⚠️ Si ya iniciaste sesión antes con Google, por favor usa ese método.
                </Alert>

                {errorMsg && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {errorMsg}
                    </Alert>
                )}

                {successMsg && (
                    <Alert severity="success" sx={{ mb: 2 }}>
                        {successMsg}
                    </Alert>
                )}

                <Box component="form" onSubmit={handleLogin}>
                    <TextField
                        fullWidth
                        type="email"
                        label="Correo electrónico"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        margin="normal"
                        required
                    />
                    <TextField
                        fullWidth
                        type="password"
                        label="Contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        margin="normal"
                        required
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={loading}
                        sx={{ mt: 2 }}
                    >
                        {loading ? 'Procesando...' : 'Entrar o Registrarse'}
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default LoginEmailScreen;
